import styled from "@emotion/styled";
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    FormControlLabel,
    Grid,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { order } from "../../app/apiManager/apiManager";
import { validateCoupon } from "../../app/apiManager/couponService";
import PaymentService from "../../app/apiManager/paymentService";
import CustomModal from "../../components/CustomModal/CustomModal";
import LinkText from "../../components/LinkText/LinkText";
import { PAYMENT_METHODS } from "../../const";
import {
    setAppointmentId,
    setPaymentDetails,
} from "../../reducers/appointmentInfoSlice";
import { setConsultationFee } from "../../reducers/consultationFeeSlice";
import getOriginalDateTime from "../../utils/formatAMPM";
import { getServiceTotalFee, toNumberOrZero } from "../../utils/fee";
import ShowAlert from "./ShowAlert";

const StepFour = ({
                      setShowing,
                      setSideMenuOpen,
                      setPaymentStatus,
                      makeAppontment,
                      isOtherCountry,
                      doctor,
                  }) => {
    const navigate = useNavigate();
    const session = useSelector((state) => state.placeAppointment.session);
    const consultationFee = useSelector(
        (state) => state.consultationFee.consultationFee
    );
    const selectedService = useSelector((state) => state.placeAppointment.service);
    const serviceTotalFee = getServiceTotalFee(selectedService);
    const baseFee =
        serviceTotalFee != null
            ? serviceTotalFee
            : toNumberOrZero(consultationFee?.totalFee);

    const channelingFee = consultationFee?.discountedPrice != null
        ? toNumberOrZero(consultationFee?.discountedPrice)
        : baseFee;

    const sessionId = session?.sessionId;
    const loadingStatus = useSelector((state) => state.loadingStatus);
    const appointmentDateTime = session?.timeStart;
    const patientId = useSelector((state) => state.appointmentInfo.patientId);
    const patientName = useSelector((state) => state.appointmentInfo.patientName);
    const patientMobileNo = useSelector((state) => state.appointmentInfo.phoneNo);
    const patientEmail = useSelector(
        (state) => state.appointmentInfo.patientEmail
    );
    const sessionType = useSelector(
        (state) => state.placeAppointment.session.type
    );
    const doctorId = useSelector(
        (state) => state.placeAppointment.doctor.doctorId
    );

    const StyledTextField = styled(TextField)({
        ".MuiInput-underline": {
            marginTop: 4,
        },
    });
    const [promoCode, setPromoCode] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [paymentOption, setPaymentOption] = useState("Loading...");
    const [isFree, setIsFree] = useState(false);
    // const [isFree, setIsFree] = useState( appointmentDateTime.toLocaleString('en-us', {year: 'numeric', month: '2-digit', day: '2-digit'}).
    // replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2')=="2023-04-05");
    const [couponCode, setCouponCode] = useState("");
    const [couponValidationResponse, setCouponValidationResponse] = useState({});
    const [totalConsultationFee, setTotalConsultationFee] =
        useState(consultationFee);

    const dispatch = useDispatch();

    const calculateEstimatedAppointmentStartTime = (dateTime) => {
        dateTime = new Date(dateTime);
        dateTime = dateTime.setMinutes(dateTime.getMinutes() + 15);
        return dateTime;
    };

    useEffect(() => {
        // console.log(appointmentDateTime);
        if (isFree) {
            setShowPopup(true);
        }
    }, [isFree]);

    const isPromoInvalid =
        promoCode.length > 0 && promoCode.toLowerCase() !== "staff";

    const couponValidate = async () => {
        try {
            const response = await validateCoupon({
                couponCode: couponCode,
                patientId: patientId,
            });
            console.log("validate response", response);
            if (response?.status === 1000) {
                setCouponValidationResponse(response?.data);
                if (response?.data?.Status === "Valid") {
                    if (response?.data?.Type === "Precentage") {
                        dispatch(
                            setConsultationFee({
                                ...consultationFee,
                                totalFee: baseFee,
                                discountedPrice:
                                    baseFee - (baseFee * response?.data?.Value) / 100,
                                coupon: { ...response?.data, couponCode: couponCode },
                            })
                        );
                    } else if (response?.data?.Type === "Value") {
                        dispatch(
                            setConsultationFee({
                                ...consultationFee,
                                totalFee: baseFee,
                                discountedPrice:
                                    baseFee - response?.data?.Value,
                                coupon: { ...response?.data, couponCode: couponCode },
                            })
                        );
                    }
                }
            }
        } catch (e) {
            // if (e?.response?.data?.status === "error") {
            dispatch(setConsultationFee({ totalFee: baseFee }));
            // }
        }
    };

    const handlePayment = () => {
        setPaymentStatus({
            isVisible: true,
            content: "loading",
        });

        if (paymentOption === PAYMENT_METHODS.PAY_NOW) {
            // dispatch(
            //   setAppointmentId({
            //     appointmentId: data.Id,
            //   })
            // );
            order(
                doctorId,
                channelingFee,
                isOtherCountry,
                patientEmail,
                patientMobileNo,
                patientId,
                selectedService?.ServiceName,
                (data) => {
                    let payUrl = data.data.data.payUrl;
                    let reference = data.reference;
                    let trnId = payUrl.substring(payUrl.indexOf("=") + 1);
                    setPaymentStatus({
                        isVisible: false,
                        content: "",
                    });
                    dispatch(
                        setPaymentDetails({
                            txnId: trnId,
                            reference: reference,
                        })
                    );
                    window.location.replace(payUrl);
                },
                () => {
                    //TODO: handle error
                    setPaymentStatus({
                        isVisible: false,
                        content: "",
                    });
                }
            );
        } else if (
            paymentOption === PAYMENT_METHODS.CASH_PAYMENT &&
            promoCode.toLowerCase() !== "staff" &&
            !isFree
        ) {
            setPaymentStatus({
                isVisible: false,
                content: "",
            });
            makeAppontment(PAYMENT_METHODS.CASH_PAYMENT);
        } else {
            setPaymentStatus({
                isVisible: false,
                content: "",
            });
            makeAppontment(PAYMENT_METHODS.PROMO);
        }
    };

    const makePayment = async () => {
        try {
            setPaymentStatus({
                isVisible: true,
                content: "loading",
            });

            const serviceId = selectedService?.ServiceId;

            let paymentGatewayRef = "";
            let makeOrderResponse = null;

            if (paymentOption === "Online Full Payment") {
                makeOrderResponse = await PaymentService.makeOrder({
                    doctorId,
                    channelingFee,
                    isOtherCountry,
                    patientEmail,
                    patientMobileNo,
                    patientId,
                    serviceName: selectedService?.ServiceName,
                });
                paymentGatewayRef = makeOrderResponse?.data?.data?.trId;
            }
            console.log(serviceId);

            if (paymentOption === "Online Full Payment" && !paymentGatewayRef) {
                setPaymentStatus({
                    isVisible: true,
                    content: "payment_gateway_error",
                });
                return;
            }

            const makeOnlineAppointmentResponse =
                await PaymentService.makeOnlineAppointment({
                    patientId,
                    sessionId, // for now
                    couponCode,
                    paymentMethod:
                        paymentOption === "Online Full Payment"
                            ? "Pay Online"
                            : "Pay At Hospital",
                    paymentGatewayRef: `${paymentGatewayRef}`,
                    ServiceId: serviceId || 0,
                });

            console.log(makeOnlineAppointmentResponse);

            if (
                paymentOption === "Online Full Payment" &&
                makeOnlineAppointmentResponse?.status === 1000
            ) {
                setPaymentStatus({
                    isVisible: false,
                    content: "",
                });
                dispatch(
                    setPaymentDetails({
                        txnId: makeOrderResponse?.data?.data?.trId,
                        reference: makeOrderResponse?.reference,
                    })
                );

                dispatch(
                    setAppointmentId({
                        appointmentId: makeOnlineAppointmentResponse?.data?.AppointmentId,
                    })
                );

                if (
                    consultationFee?.totalFee > 0 ||
                    (consultationFee?.discountedPrice &&
                        consultationFee?.discountedPrice > 0)
                ) {
                    if (makeOrderResponse?.data?.data?.payUrl) {
                        window.location.replace(makeOrderResponse?.data?.data?.payUrl);
                    } else {
                        console.log("Payment Failed");
                        navigate(
                            `/status?appointmentId=${makeOnlineAppointmentResponse?.data?.AppointmentId}`
                        );
                    }
                }
            } else {
                setPaymentStatus({
                    isVisible: false,
                    content: "",
                });
                navigate(
                    `/status?appointmentId=${makeOnlineAppointmentResponse?.data?.AppointmentId}`
                );
            }
        } catch (e) {
            console.error(e);
        } finally {
            // setPaymentStatus({
            //   isVisible: false,
            //   content: "",
            // });
        }
    };

    const fetchDoctorPaymentPolicy = async () => {
        try {
            const doctorPaymentPolicy = await PaymentService.getDoctorPaymentPolicy({
                InstituteBranchId: process.env.REACT_APP_BRANCH_ID,
                DoctorId: doctorId,
                SessionType: sessionType,
            });
            console.log(doctorPaymentPolicy);
            if (
                Array.isArray(doctorPaymentPolicy?.data) &&
                doctorPaymentPolicy?.data?.length > 0
            ) {
                setPaymentOption(doctorPaymentPolicy?.data[0].PaymentType);
            } else {
                setPaymentOption("Online Full Payment");
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchDoctorPaymentPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionType]);

    return (
        <Grid item xs={12} sm lg sx={{ height: "30rem", mt: { xs: 2, sm: 0 } }}>
            <div>
                <Typography fontWeight={"bold"} fontSize={"1.3rem"}>
                    Appointment Info
                </Typography>
                <Box mt={2}>
                    <Grid container>
                        <Grid item xs={5.5}>
                            <Typography fontWeight={"medium"}>Ref No</Typography>
                            <Typography>{sessionId} </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography fontWeight={"bold"}>Appoinment Date</Typography>
                            <Typography>
                                {getOriginalDateTime(appointmentDateTime).toLocaleDateString()}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container mt={2}>
                        <Grid item fontWeight={"bold"} xs={5.5}>
                            <Typography fontWeight={"bold"}>Patient Name</Typography>
                            <Typography>{patientName}</Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography fontWeight={"bold"}>Appoinment Time</Typography>
                            <Typography>
                                {format(getOriginalDateTime(appointmentDateTime), "p")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </div>

            <Grid container mt={2}>
                {patientMobileNo.length > 0 && (
                    <Grid item xs={5.5}>
                        <Typography fontWeight={"bold"}>Mobile No</Typography>
                        <Typography>{patientMobileNo}</Typography>
                    </Grid>
                )}

                {patientEmail ? (
                    <Grid item xs>
                        <Typography fontWeight={"bold"}>Email Address</Typography>
                        <Typography>{patientEmail}</Typography>
                    </Grid>
                ) : null}
            </Grid>
            <Divider
                orientation="horizontal"
                sx={{
                    backgroundColor: "#ABABAB",
                    mt: 2,
                    mb: 2,
                }}
            />

            <Grid container mt={2} gap={2}>
                <Grid item xs>
                    <Typography fontWeight={"bold"}>Payment Method </Typography>
                    <StyledTextField
                        readOnly
                        label=" "
                        fullWidth
                        variant="standard"
                        sx={{
                            mt: 0,
                        }}
                        inputProps={{ readOnly: true }}
                        value={
                            paymentOption
                            // isOtherCountry
                            //   ? "USD 10.00"
                            //   : convertToCurrency({
                            //       amount:
                            //         doctor.doctorFee +
                            //         doctor.hospitalFee +
                            //         parseFloat(process.env.REACT_APP_SERVICE_FEE),
                            //       currency: "LKR",
                            //     })
                        }
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>
                        Coupon Code
                        {/* {isPromoInvalid && (
              <span
                style={{
                  color: "red",
                  fontSize: "10px",
                }}
              >
                {" "}
                invalid code
              </span>
            )} */}
                    </Typography>
                    <TextField
                        sx={{
                            mt: 1,
                        }}
                        variant="standard"
                        onChange={(event) => {
                            const value = event.target.value;
                            setCouponCode(value);
                        }}
                        value={couponCode}
                        fullWidth
                        size="small"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Button
                                        size="small"
                                        variant="contained"
                                        sx={{ borderRadius: 2, mb: 1.5 }}
                                        onClick={couponValidate}
                                    >
                                        Apply
                                    </Button>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
            </Grid>

            <Grid container mt={2} sx={{ visibility: "hidden" }}>
                <RadioGroup row defaultValue={PAYMENT_METHODS.PAY_NOW}>
                    <FormControlLabel
                        value={PAYMENT_METHODS.PAY_NOW}
                        control={
                            <Radio
                                onClick={() => {
                                    setPaymentOption(PAYMENT_METHODS.PAY_NOW);
                                }}
                                disabled={!isPromoInvalid && promoCode.length > 0}
                            />
                        }
                        label="Pay online"
                    />
                    <FormControlLabel
                        value={PAYMENT_METHODS.CASH_PAYMENT}
                        control={
                            <Radio
                                onClick={() => {
                                    setPaymentOption(PAYMENT_METHODS.CASH_PAYMENT);
                                }}
                                disabled={!isPromoInvalid && promoCode.length > 0}
                            />
                        }
                        label="Pay at hospital"
                    />
                    <FormControlLabel
                        sx={{
                            display: "none",
                        }}
                        value={PAYMENT_METHODS.PAY_LATER}
                        title={
                            sessionType === 1 || sessionType === 3
                                ? "Pay later is not available for video consultations"
                                : ""
                        } // 1 is video call and 3 is hybrid
                        disabled={sessionType === 1 ? true : false} // 1 is video call
                        control={
                            <Radio
                                onClick={() => {
                                    setPaymentOption(PAYMENT_METHODS.PAY_LATER);
                                }}
                            />
                        }
                        label="Pay Later"
                    />
                </RadioGroup>
            </Grid>
            <Typography sx={{ my: 1 }}>
                By clicking complete, you agree to our{" "}
                <LinkText
                    text={"terms and conditions"}
                    onClick={() => {
                        setShowing(1);
                        setSideMenuOpen(true);
                    }}
                />
            </Typography>

            <Box mt={2} display="flex" gap={2}>
                <Button
                    variant="contained"
                    onClick={makePayment}
                    disabled={paymentOption === "Loading..."}
                >
                    Continue
                    {loadingStatus.placeAppointment && (
                        <CircularProgress
                            size={15}
                            sx={{
                                ml: 1,
                                color: "white",
                            }}
                        />
                    )}
                </Button>
            </Box>
            <CustomModal open={showPopup}>
                <ShowAlert
                    onClick={() => {
                        setShowPopup(false);
                        // setPaymentStatus({ isVisible: false, content: "" });
                        // dispatch(
                        //     setStep({
                        //         step: 0,
                        //     })
                        // );
                        // navigate(`/status?appointmentId=${appointmentId}`);
                    }}
                />
            </CustomModal>
        </Grid>
    );
};

export default StepFour;